import React, { useEffect, useRef } from 'react';
import { useSiteContent } from '../../context/SiteContentContext';
import { getMediaUrl } from '../../services/api';

export function ReviewCard({ item }) {
    return (
        <div className="testimonials-three__single">
            <div className="quote-icon"><span className="fa fa-quote-right" /></div>
            {item.image && <div className="img-box"><img src={getMediaUrl(item.image)} alt={item.name} /></div>}
            <div className="testimonials-three__single-inner">
                <div className="title-box"><h3>{item.name}</h3><span>{item.role}</span></div>
                <div className="text-box"><p style={{ whiteSpace: 'pre-line' }}>{item.text}</p></div>
                <ul className="rating-box" aria-label={`${item.stars} out of 5 stars`}>
                    {Array.from({ length: Math.max(0, Math.min(5, Number(item.stars) || 0)) }, (_, i) => <li key={i}><span className="icon-star" /></li>)}
                </ul>
            </div>
        </div>
    );
}

export default function TestimonialThree() {
    const { content } = useSiteContent();
    const section = content.testimonials;
    const items = section?.items || [];
    const carouselRef = useRef(null);

    useEffect(() => {
        const $ = window.$;
        const carousel = carouselRef.current;
        if (!carousel || !items.length || !$?.fn?.owlCarousel) return undefined;

        const initialize = () => {
            const $carousel = $(carousel);
            if ($carousel.hasClass('owl-loaded')) $carousel.trigger('destroy.owl.carousel');
            $carousel.owlCarousel({
                loop: true, margin: 50, nav: true, smartSpeed: 500,
                autoHeight: false, autoplay: true, dots: false, autoplayTimeout: 10000,
                navText: ['<i class="icon-right-arrow left"></i>', '<i class="icon-right-arrow"></i>'],
                responsive: { 0: { items: 1 }, 600: { items: 1 }, 800: { items: 2 }, 992: { items: 2 }, 1200: { items: 2 } }
            });
        };

        const frame = requestAnimationFrame(initialize);
        return () => {
            cancelAnimationFrame(frame);
            const $carousel = $(carousel);
            if ($carousel.hasClass('owl-loaded')) $carousel.trigger('destroy.owl.carousel');
        };
    }, [items.length]);

    if (!items.length) return null;
    const publicUrl = process.env.PUBLIC_URL + '/';

    return (
        <section className="testimonials-three">
            {Array.from({ length: 9 }, (_, i) => <div key={i} className={`testimonials-three__img${i + 1} ${i % 3 === 0 ? 'zoom-fade' : 'float-bob-y'}`}>
                <img src={`${publicUrl}assets/images/update1.0/testimonials-v3-img${[7, 3, 4, 10, 1, 8, 6, 5, 9][i]}.jpg`} alt="" />
            </div>)}
            <div className="container">
                <div className="sec-title">
                    <div className="sec-title__tagline"><h6>{section.subtitle}</h6><span className="right" /></div>
                    <h2 className="sec-title__title">{section.title}</h2>
                </div>
                <div className="row"><div className="col-xl-12">
                    <div ref={carouselRef} className="testimonials-three__carousel owl-carousel owl-theme">
                        {items.map((item, index) => <ReviewCard item={item} key={item.id || index} />)}
                    </div>
                </div></div>
            </div>
        </section>
    );
}
